// 字典
export const errorTitle = '错误'
export const asyncTime = 1000
